import DOMPurify from 'dompurify';
import { Filter } from 'bad-words';

const profanityFilter = new Filter();

function stripFormatting(html) {
  const tempEl = document.createElement('div');
  tempEl.innerHTML = html.replace(/&nbsp;/g, ' ');
  Array.from(tempEl.querySelectorAll('b,i,a,span')).forEach((el) => {
    el.replaceWith(el.textContent);
  });
  return tempEl.textContent || '';
}

export function getDisplayLength(html) {
  if (!html) return 0;
  return stripFormatting(html).length;
}

export const validateTextInput = (text, options = {}) => {
  const {
    maxLength,
    minLength,
    allowSpecialChars = true,
    disallowLinks = false,
    field_name = "Input",
    allowed_special_chars = ""
  } = options;
  let errors = [];
  let sanitizedText = DOMPurify.sanitize(text, {
    ALLOWED_TAGS: ['b', 'i', 'a', 'span', 'div', 'br', 'p'],
    ALLOWED_ATTR: ['href']
  });
  const lengthCheckText = stripFormatting(sanitizedText);
  const hasUnclosedTag = text.indexOf('<') !== -1 && text.indexOf('>') === -1;
  if (field_name.toLowerCase() === "username") {
    const usernameRegex = /^[a-zA-Z0-9\-_]+$/;
    if (!usernameRegex.test(text.trim())) {
      errors.push("Your username can only include letters, numbers, hyphens, and underscores.");
    }
  }
  if (!hasUnclosedTag) {
    if (maxLength && lengthCheckText.length > maxLength) {
      errors.push(`Text cannot exceed ${maxLength} characters.`);
    }
    if (minLength && lengthCheckText.length < minLength) {
      errors.push(`Text must be at least ${minLength} characters long.`);
    }
    if (profanityFilter.isProfane(sanitizedText)) {
      errors.push('Please remove offensive language.');
    }
    if (!allowSpecialChars) {
      if (/[^a-zA-Z0-9\s-_]/.test(sanitizedText)) {
        errors.push('Input contains invalid characters. Only letters, numbers, spaces, underscores, and hyphens are allowed.');
      }
    }
    if (disallowLinks) {
      const linkTagRegex = /<a\s+href="[^"]*"/i;
      const plainUrlRegex = /https?:\/\/[^\s]+/i;
      if (linkTagRegex.test(sanitizedText) || plainUrlRegex.test(sanitizedText)) {
        errors.push('Links are not allowed.');
      }
    } else {
      const linkRegex = /<a\s+href="([^"]*)"/gi;
      let match;
      while ((match = linkRegex.exec(sanitizedText)) !== null) {
        try {
          const url = new URL(match[1]);
          let domain = url.hostname.toLowerCase();
          if (domain.startsWith('www.')) {
            domain = domain.slice(4);
          }
          const scheme = url.protocol.replace(':', '');
          if (!['https'].includes(scheme)) {
            errors.push(`Link with disallowed scheme: ${scheme || 'none'}`);
          }
        } catch {
          errors.push(`Invalid link format: ${match[1]}`);
        }
      }
    }
  }
  return {
    isValid: errors.length === 0,
    errors,
    sanitizedText
  };
};
